<div class="navbar navbar-expand-md navbar-dark">
	<a class="navbar-brand gorm-logo" (click)="navigate(logoLink)"></a>
	<div class="user-icon"><img [userImage]="user.id" /></div>
	<div class="user-details">
		{{ user.internalPhone + ' ' + (user | user: 'initials') }}
		<div class="user-name">{{ user | user: 'name' }}</div>
	</div>
	
	<div class="quick-links">
		<div (click)="openUserSettings()" [title]="'navmenu.user-settings' | translate"><icon type="user-gear" /></div>
		@for (link of quickLinks; track link) {
		<div (click)="navigateQuickLink(link)" [title]="link.title"><icon [type]="link.icon" /></div>
		}
	</div>
	<div class="navbar-collapse collapse justify-content-end" dropdown-parent (onDropdownClosed)="openMenu = undefined">
		<ul class="navbar-nav">
			@for (subMenu of menu.subMenus; track subMenu.label) {
			<li class="nav-item" (dropdown-trigger)="openMenu = subMenu">
				<a class="nav-link" [ngClass]="{ active: (openMenu == subMenu || activeSubMenu == subMenu) }" data-toggle="dropdown">{{ 'navmenu.' + subMenu.label | translate }}</a>
				<dropdown-menu right-align>
					@for (menuItem of subMenu.menuItems; track menuItem.component) {
					<menu-item [highlight]="activeMenuItem == menuItem" (action)="navigate(menuItem)">{{ 'navmenu.' + subMenu.label + '.' + menuItem.label | translate }}</menu-item>
					}
				</dropdown-menu>
			</li>
			}
		</ul>
	</div>
</div>
